module.exports = __webpack_public_path__ + "static/media/102.8f9df985.jpg";